var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6152 2H5.38523C3.78773 2 2.49023 3.305 2.49023 4.895V15.4625C2.49023 16.8125 3.45773 17.3825 4.64273 16.73L8.30273 14.6975C8.69273 14.48 9.32273 14.48 9.70523 14.6975L13.3652 16.73C14.5502 17.39 15.5177 16.82 15.5177 15.4625V4.895C15.5102 3.305 14.2127 2 12.6152 2Z",
    stroke: "#2C323F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19238 8.75L8.31738 9.875L11.3174 6.875",
    stroke: "#2C323F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon03);
export default __webpack_public_path__ + "static/media/header-icon-03.de965d09147c4a7bec15d6392f993833.svg";
export { ForwardRef as ReactComponent };